define(['exports', 'react', 'lodash', '../../i18n', './styles/CandidateReportsView.css'], function (exports, _react, _lodash, _i18n) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var CoveredConceptsTable = function (_Component) {
		_inherits(CoveredConceptsTable, _Component);

		function CoveredConceptsTable() {
			_classCallCheck(this, CoveredConceptsTable);

			return _possibleConstructorReturn(this, (CoveredConceptsTable.__proto__ || Object.getPrototypeOf(CoveredConceptsTable)).apply(this, arguments));
		}

		_createClass(CoveredConceptsTable, [{
			key: 'renderTableTitle',
			value: function renderTableTitle() {

				return _react2.default.createElement(
					'div',
					{ className: 'main-heading-secondary nunito-font' },
					_i18n2.default.t('dk-ui-lib.reports.concepts_covered')
				);
			}
		}, {
			key: 'renderTableHeader',
			value: function renderTableHeader() {
				return _react2.default.createElement(
					'div',
					{ className: 'mt3 flex justify-between field-name-primary' },
					_react2.default.createElement(
						'div',
						{ className: 'col-8' },
						_i18n2.default.t('dk-ui-lib.reports.concept_name')
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-2' },
						_i18n2.default.t('dk-ui-lib.reports.correctness')
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-2 display-none' },
						_i18n2.default.t('dk-ui-lib.reports.speed')
					)
				);
			}
		}, {
			key: 'renderCoveredConcept',
			value: function renderCoveredConcept(concept) {

				return _react2.default.createElement(
					'div',
					{ className: 'mt2 flex justify-between border-bottom pb1 black bold' },
					_react2.default.createElement(
						'div',
						{ className: 'col-8' },
						concept.name
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-2' },
						concept.correctnessPercentage && concept.correctnessPercentage.toFixed(2),
						' %'
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-2 display-none' },
						concept.speed,
						' %'
					)
				);
			}
		}, {
			key: 'renderCoveredConcepts',
			value: function renderCoveredConcepts() {
				var _this2 = this;

				return _react2.default.createElement(
					'div',
					null,
					(this.props.conceptsCovered || []).map(function (concept, index) {
						return _this2.renderCoveredConcept(concept);
					})
				);
			}
		}, {
			key: 'renderEmptyPlaceHolder',
			value: function renderEmptyPlaceHolder() {
				return _react2.default.createElement(
					'div',
					{ className: 'center mt3' },
					'N/A'
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var conceptsCovered = this.props.conceptsCovered;


				return _react2.default.createElement(
					'div',
					{ className: 'clearfix mt2 px1 pt2 pb3 rounded', style: { backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.02)' } },
					this.renderTableTitle(),
					this.renderTableHeader(),
					!_lodash2.default.isEmpty(conceptsCovered) && this.renderCoveredConcepts(),
					_lodash2.default.isEmpty(conceptsCovered) && this.renderEmptyPlaceHolder()
				);
			}
		}]);

		return CoveredConceptsTable;
	}(_react.Component);

	exports.default = CoveredConceptsTable;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/CoveredConceptsTable.js
// module id = 463
// module chunks = 0